var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelogio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "relogio") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Home_Pesquisa",
    transform: "translate(-1416.000000, -11263.000000)",
    stroke: "",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy",
    transform: "translate(986.000000, 10975.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.457051,305.365869 C443.875329,305.365869 447.457051,301.784147 447.457051,297.365869 C447.457051,292.947591 443.875329,289.365869 439.457051,289.365869 C435.038773,289.365869 431.457051,292.947591 431.457051,297.365869 C431.457051,301.784147 435.038773,305.365869 439.457051,305.365869 Z M442.527142,300.159877 L439.474834,298.338338 C438.943142,298.023261 438.509911,297.265107 438.509911,296.644799 L438.509911,292.607876",
    id: "relogio"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelogio);
export default __webpack_public_path__ + "static/media/relogio.72559d88d4dd52a8bc0d7bb5e301808e.svg";
export { ForwardRef as ReactComponent };